<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <leaves-admin-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :hasCreatePermission="hasCreatePermission"
          :hasImportPermission="hasImportPermission"
          @reset-data="resetFormData"
        />

        <div class="row">
          <div class="col-md-12">
            <div class="showentries mb-3">
              <label>
                Show
                <select v-model="pagination.pageSize" @change="updatePerPage">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
            <div>
              <a-table
                class="stripped table-hover"
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                @change="handleTableChange"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'file_name'">
                    <a
                      class="text-decoration-underline"
                      :href="docPath(record?.file_path)"
                      target="_blank"
                    >
                      {{ record?.file_name }}
                    </a>
                  </template>

                  <template v-if="column.key === 'first_name'">
                    <h2 class="table-avatar">
                      <router-link
                        :to="'profile/' + record?.user?.id"
                        class="avatar"
                      >
                        <img
                          v-if="record?.user?.avatar"
                          :src="getEmployeeAvatar(record?.user?.avatar)"
                          alt="User Image"
                          @error="handleImageError(record?.user)"
                        />
                        <img
                          v-else
                          :src="
                            require(`@/assets/img/profiles/${defaultAvatar}`)
                          "
                          alt="User Image"
                        />
                      </router-link>
                      <router-link :to="'profile/' + record?.user?.id"
                        >{{ record?.user?.first_name }}
                        {{ record?.user?.last_name }}</router-link
                      >
                    </h2>
                    <!-- <div>{{ record?.user?.first_name }}</div><div>{{ record?.user?.last_name }}</div> -->
                  </template>
                  <template v-if="column.key === 'created_at'">
                    <div>
                      {{ formatDate(record?.created_at) || record?.created_at }}
                    </div>
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <td class="text-end">
                      <div class="dropdown dropdown-action">
                        <a
                          href="javascript:;"
                          class="action-icon dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          ><i class="material-icons">more_vert</i></a
                        >
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="hasDeletePermission"
                            class="dropdown-item"
                            href="javascript:;"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteDocumentConfirmationModal"
                            @click="
                              deleteDocumentID(record?.organization_document_id)
                            "
                            ><i class="fa-regular fa-trash-can m-r-5"></i>
                            Delete</a
                          >
                        </div>
                      </div>
                    </td>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <!-- Closing for .content.container-fluid -->
    </div>
    <!-- Closing for .page-wrapper -->
    <div id="upload_document" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload Document</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="impdeptclose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Form @submit="onSubmit">
              <!-- File Name -->
              <!-- <div class="input-block mb-3">
                <label class="col-form-label">
                  File Name <span class="text-danger">*</span>
                </label>
                <Field
                  name="file_name"
                  type="text"
                  class="form-control"
                  v-model="form.file_name"
                  :class="{ 'is-invalid': errors.file_name }"
                />
                <div class="invalid-feedback">{{ errors.file_name }}</div>
                <div class="file_nameshow text-danger" id="file_name"></div>
              </div> -->
              <!-- Dynamic File Inputs -->
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Files <span class="text-danger">*</span></label
                >
                <div
                  v-for="(fileInput, index) in fileInputs"
                  :key="fileInput.id"
                  class="d-flex mb-2"
                >
                  <input
                    type="file"
                    class="form-control me-2"
                    :ref="'fileInput' + index"
                    @change="handleDynamicFileUpload($event, index)"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.rtf,.odt,.ods,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.csv,.zip,.html,.htm"
                  />
                  <button
                    v-if="fileInputs.length > 1"
                    type="button"
                    class="btn btn-danger"
                    @click="removeFileInput(index)"
                  >
                    Remove
                  </button>
                </div>

                <button
                  type="button"
                  class="btn btn-success mt-2"
                  @click="addFileInput"
                >
                  + Add File
                </button>
              </div>

              <!-- NOTE -->
              <small class="form-text text-muted mt-2">
                <i class="fas fa-info-circle"></i>
                Note: The uploaded file’s name will automatically be used as the
                document name (without extension).
              </small>
              <div class="submit-section">
                <button class="btn btn-primary submit-btn">Submit</button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Overtime Modal -->
    <div
      class="modal custom-modal fade"
      id="deleteDocumentConfirmationModal"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Delete Document</h3>
              <p>Are you sure want to delete?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-primary continue-btn"
                    @click="deleteDocument"
                    >Delete</a
                  >
                </div>
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    data-bs-dismiss="modal"
                    class="btn btn-primary cancel-btn"
                    @click="cancleDelete"
                    ref="departmentsmodel"
                    >Cancel</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Delete Overtime Modal -->
  </div>
  <!-- Closing for .main-wrapper -->
</template>

<script>
import axios from "axios";
import { notification } from "ant-design-vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import moment from "moment";

var pagination = { total: 0, current: 1, pageSize: 10 };

const columns = [
  {
    title: "Sr No.",
    dataIndex: "id",
    key: "id",
    customRender: ({ index }) => {
      return pagination.current === 1
        ? index + 1
        : (pagination.current - 1) * pagination.pageSize + (index + 1);
    },
  },
  {
    title: "Document Name",
    dataIndex: "file_name",
    key: "file_name",
    sorter: {
      compare: (a, b) => {
        a = a.file_name.toLowerCase();
        b = b.file_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Uploaded By",
    dataIndex: "first_name",
    key: "first_name",
    sorter: {
      compare: (a, b) => {
        a = a.first_name.toLowerCase();
        b = b.first_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Uploaded At",
    dataIndex: "created_at",
    key: "created_at",
    sorter: {
      compare: (a, b) => {
        a = a.created_at.toLowerCase();
        b = b.created_at.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  // {
  //   title: "Action",
  //   sorter: false,
  //   key: "action",
  // },
];

const data = [];

export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      title: "Organization Documents",
      path: "Dashboard",
      text: "Organization Documents",
      text1: " Add Document",
      hasEditPermission: null,
      hasReadPermission: null,
      hasDeletePermission: null,
      hasCreatePermission: null,
      hasImportPermission: null,
      pagination,
      columns,
      data,
      files: [],
      fileInputs: [{ id: Date.now() + Math.random(), file: null }],
      form: {
        file_name: null,
      },
      delete_document_id: null,
      defaultAvatar: "avatar-01.jpg",
    };
  },
  methods: {
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    handleImageError(record) {
      record.avatar = null;
      record.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    resetFormData() {
      this.form.file_name = null;
      this.files = [];
      this.fileInputs = [{ id: Date.now() + Math.random(), file: null }];
    },
    deleteDocumentID(delete_document_id) {
      this.delete_document_id = delete_document_id;
    },
    cancleDelete() {
      this.delete_document_id = null;
    },
    deleteDocument() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .delete("/organization-document/" + this.delete_document_id, [])
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs?.departmentsmodel?.click();

          var params = {
            params: { per_page: this.pagination.pageSize },
          };

          this.loadCommonData(params);
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    dateFormate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    addFileInput() {
      // this.fileInputs.push(null);
      this.fileInputs.push({ id: Date.now() + Math.random(), file: null });
    },
    removeFileInput(index) {
      this.fileInputs.splice(index, 1);
      this.files.splice(index, 1);
    },
    handleDynamicFileUpload(event, index) {
      const file = event?.target?.files?.[0] ?? null;

      if (!file) {
        if (index < this.files.length) this.files.splice(index, 1, null);
        return;
      }

      if (index >= this.files.length) {
        for (let i = this.files.length; i <= index; i++) {
          this.files[i] = null;
        }
      }

      this.files[index] = file;
    },
    onSubmit() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      if (!this.files.length) {
        notification.open({
          message: "Please select at least one file",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
        return;
      }
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var form = new FormData();

      this.files.forEach((file) => {
        if (file) {
          form.append("documents[]", file);
        }
      });
      // form.append("file_name", this.form.file_name);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      axios
        .post("/organization-document/upload", form, config)
        .then((response) => {
          this.files = [];
          this.fileInputs = [{ id: Date.now() + Math.random(), file: null }];

          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Uplaoded",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.impdeptclose.click();
          this.form.file_name = null;
          var params = {
            params: { per_page: this.pagination.pageSize },
          };

          this.loadCommonData(params);
        })
        .catch((error) => {
          this.files = [];
          this.fileInputs = [{ id: Date.now() + Math.random(), file: null }];

          loader.hide();

          if (error.response) {
            var response = error.response;

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadCommonData(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/organization-document", params)
        .then((response) => {
          this.pagination.total = response.data.data.total;
          this.pagination.current = response.data.data.current_page;
          this.pagination.pageSize = response.data.data.per_page;

          this.data = response.data.data.data;

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    updatePerPage() {
      var params = {
        params: { per_page: this.pagination.pageSize },
      };

      this.loadCommonData(params);
    },
    handleTableChange(pagesize) {
      var params = {
        params: { per_page: pagesize.pageSize, page: pagesize.current },
      };
      this.loadCommonData(params);
    },
    docPath(path) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${path}`;
    },
  },
  created() {
    this.$store
      .dispatch("userPermissions", {
        module: "organization_document",
        action: "read",
      })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", {
        module: "organization_document",
        action: "create",
      })
      .then((response) => {
        this.hasCreatePermission = null;
        this.$nextTick(() => {
          this.hasCreatePermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", {
        module: "organization_document",
        action: "delete",
      })
      .then((response) => {
        this.hasDeletePermission = null;
        this.$nextTick(() => {
          this.hasDeletePermission = response === "true";

          if (this.hasDeletePermission) {
            this.columns = [
              ...columns,
              {
                title: "Action",
                sorter: false,
                key: "action",
                // class: "text-end",
              },
            ];
          }
        });
      });

    var params = {
      params: { per_page: this.pagination.pageSize },
    };

    this.loadCommonData(params);
  },
  // setup() {
  //   const schema = Yup.object().shape({
  //     // document: Yup.string().required("File is required"),
  //     // file_name: Yup.string().required("File Name is required"),
  //   });
  //   return {
  //     schema,
  //   };
  // },
};
</script>
